import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, Ref } from "vue"
import Icon from "@/components/widgets/icons/Icon.vue"
import { Actions } from "@/modules/Missions/components/Details/ManageTeamRoles/constant"
import {
  MissionStaffingPositionFragmentFragment,
  MissionStaffingPositionDetailFragmentFragment,
} from "@/gql"
import { useStaffingPositionContext } from "./StaffingPositionDetails/useStaffingPositionContext"
import { useNotification } from "@/hooks/useNotification"
import { useUtilities } from "@/hooks/useUtilities"
import { useMissionLifecycleContext } from "@/modules/Missions/hooks/useMissionLifecycleContext"
import TeamRoleStateChip from "./TeamRoleStateChip.vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'TeamRoleCard',
  props: {
    role: null
  },
  emits: ["click", "action"],
  setup(__props: any, { emit: emits }) {

const props = __props as {
  role: MissionStaffingPositionFragmentFragment
}




const { addError } = useNotification()

const { canPublishApplication } = useStaffingPositionContext(
  ref(props.role) as Ref<MissionStaffingPositionDetailFragmentFragment>
)
const { mission } = useMissionLifecycleContext()

const pendingApplications = computed(() => {
  return mission.operational && props.role.pendingMissionStaffingApplications.length
    ? props.role.pendingMissionStaffingApplications.length
    : 0
})

const state = computed(() => {
  return props.role.state
})

const onMissionClick = (event: Event) => {
  event.stopImmediatePropagation()
  emits("click")
}

const onPublishApplication = () => {
  if (!canPublishApplication.value) {
    addError(
      "To publish this role please ensure the mission has a scope, start and end date have been set, and payments have been configured"
    )
    return
  }
  emits("action", Actions.Publish)
}
const { pluralize } = useUtilities()

const pendingApplicationsLabel = computed(() =>
  pluralize(pendingApplications.value, "new application")
)

return { __sfc: true,props, emits, addError, canPublishApplication, mission, pendingApplications, state, onMissionClick, onPublishApplication, pluralize, pendingApplicationsLabel, Icon, Actions, TeamRoleStateChip }
}

})